import { createContext, useContext, useState } from 'react';

import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { ConfirmModal } from '../Components/Manager/ConfirmModal';

const ModalContext = createContext({});

export const ModalProvider = ({ children }) => {
    const [modal, setModal] = useState({
        type: 'delete',
        confirm: null,
        onSuccess: null,
        open: false
    });

    const openModal = (data) => {
        setModal(data);
    };

    const closeModal = () =>
        setModal({
            type: 'delete',
            confirm: null,
            onSuccess: null,
            open: false
        });

    return (
        <ModalContext.Provider value={{ openModal }}>
            {children}

            {modal.open && (
                <ConfirmModal
                    icon={faTrash}
                    closeModal={closeModal}
                    type={modal.type}
                    confirm={modal.confirm}
                    onSuccess={modal.onSuccess}
                />
            )}
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);
